import { render, staticRenderFns } from "./Carga.vue?vue&type=template&id=2bb412cb&"
import script from "./Carga.vue?vue&type=script&lang=js&"
export * from "./Carga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports